import { ClerkAxiosSetup } from '@/api/ClerkAxiosSetup';
import { Toaster } from '@/components/design-system/sooner';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { clerkConfig } from '@/config/clerk.config';
import { useMockServiceWorker } from '@/hooks/useMockServiceWorker';
import { LocaleStoreSyncProvider } from '@/i18n/LocaleStoreSyncProvider';
import { AuthProvider } from '@/providers/AuthProvider';
import { MatchMediaContextProvider } from '@/providers/MatchMediaProvider';
import { OrganizationProvider } from '@/providers/OrganizationProvider';
import { router } from '@/routing/router';
import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const queryClient = new QueryClient();

export const Providers: React.FC = () => {
  const { isReady } = useMockServiceWorker();

  if (!isReady) {
    return null;
  }

  return (
    <ErrorBoundary>
      <ClerkProvider {...clerkConfig}>
        <OrganizationProvider>
          <ClerkAxiosSetup>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <MatchMediaContextProvider>
                  <RouterProvider router={router} />
                  <Toaster richColors />
                  <ReactTooltip
                    id="app-tooltip"
                    delayShow={300}
                    border="1px solid #e5e5e5"
                    opacity={1}
                    style={{
                      backgroundColor: 'white',
                      color: '#1a1a1a',
                      borderRadius: '6px',
                      padding: '4px 8px',
                      fontSize: '12px',
                      zIndex: 9999,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      maxWidth: '400px'
                    }}
                  />
                </MatchMediaContextProvider>
              </AuthProvider>
              <LocaleStoreSyncProvider />
            </QueryClientProvider>
          </ClerkAxiosSetup>
        </OrganizationProvider>
      </ClerkProvider>
    </ErrorBoundary>
  );
};
